import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { AslibAuthService } from '@aslib/security';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private router: Router,
    private authService: AslibAuthService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler) {

    return next.handle(req)
      .catch((error: HttpErrorResponse) => {

        if (error.status === 401 || error.status === 0) {

          localStorage.clear();
          sessionStorage.clear();

          this.router.navigate(['/']);
        }

        return Observable.throw(error);
      });
  }
}


// WEBPACK FOOTER //
// ./src/app/services/HttpInterceptor.ts